import { CrossFrameUtils } from '@utils/CrossFrameUtils';
/*
 * These functions call up to a service in AssociateToolsBase to start/stop the barcode scanner
 * and capture barcode data using Cordova.
 */
export const reset = () => {
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame: window.top,
        message: {
            method: 'barcodeScanner',
            data: {
                action: 'resetScannerProfile',
            },
        },
    });
};

export const startHexProfile = () => {
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame: window.top,
        message: {
            method: 'barcodeScanner',
            data: {
                action: 'startHexProfile',
            },
        },
    });
};

export const capture = () => {
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame: window.top,
        message: {
            method: 'barcodeScanner',
            data: {
                action: 'captureScan',
            },
        },
    });
};
